import { Search, Filter, ArrowUpDown } from 'lucide-react';

interface DockBoardToolbarProps {
    searchQuery: string;
    onSearchChange: (query: string) => void;
    statusFilter: string;
    onStatusFilterChange: (status: string) => void;
    typeFilter?: string;
    onTypeFilterChange?: (type: string) => void;
    sortBy: string;
    onSortChange: (sort: string) => void;
    showExceptions: boolean;
    onShowExceptionsChange: (show: boolean) => void;
}

export function DockBoardToolbar({
    searchQuery,
    onSearchChange,
    statusFilter,
    onStatusFilterChange,
    sortBy,
    onSortChange,
    showExceptions,
    onShowExceptionsChange
}: DockBoardToolbarProps) {
    return (
        <div className="flex flex-col xl:flex-row gap-4 items-center justify-between bg-card p-4 rounded-xl border shadow-sm mb-6">
            <div className="flex flex-col md:flex-row gap-3 w-full xl:w-auto flex-1">
                {/* Search */}
                <div className="relative w-full md:w-80">
                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
                    <input
                        type="text"
                        placeholder="Search docks, carriers, POs..."
                        value={searchQuery}
                        onChange={(e) => onSearchChange(e.target.value)}
                        className="w-full pl-9 pr-4 h-10 rounded-md border bg-background focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all text-sm"
                    />
                </div>

                {/* Quick Filters */}
                <div className="flex items-center gap-2">
                    <button
                        onClick={() => onShowExceptionsChange(!showExceptions)}
                        className={`h-10 px-3 rounded-md text-sm font-medium border flex items-center gap-2 transition-colors ${showExceptions
                            ? 'bg-red-500/10 text-red-600 border-red-500/20'
                            : 'bg-background hover:bg-secondary'
                            }`}
                    >
                        <Filter className="w-4 h-4" />
                        Exceptions Only
                    </button>
                    <button
                        onClick={() => onStatusFilterChange(statusFilter === 'Occupied' ? 'All' : 'Occupied')}
                        className={`h-10 px-3 rounded-md text-sm font-medium border flex items-center gap-2 transition-colors ${statusFilter === 'Occupied'
                            ? 'bg-blue-500/10 text-blue-600 border-blue-500/20'
                            : 'bg-background hover:bg-secondary'
                            }`}
                    >
                        Occupied Only
                    </button>
                </div>
            </div>

            {/* Dropdowns */}
            <div className="flex gap-3 w-full xl:w-auto overflow-x-auto pb-2 xl:pb-0 justify-end">
                <div className="flex items-center gap-2 bg-background border rounded-md px-2 h-10">
                    <ArrowUpDown className="w-4 h-4 text-muted-foreground" />
                    <select
                        value={sortBy}
                        onChange={(e) => onSortChange(e.target.value)}
                        className="h-full bg-transparent outline-none text-sm font-medium min-w-[120px]"
                    >
                        <option value="number">Dock Number</option>
                        <option value="status">Status</option>
                        <option value="dwell">Worst Dwell</option>
                        <option value="updated">Recently Updates</option>
                    </select>
                </div>

                <div className="h-4 w-px bg-border my-auto hidden md:block"></div>

                <select
                    value={statusFilter}
                    onChange={(e) => onStatusFilterChange(e.target.value)}
                    className="h-10 px-3 rounded-md border bg-background outline-none focus:ring-2 focus:ring-primary min-w-[140px] text-sm"
                >
                    <option value="All">All Statuses</option>
                    <option value="Available">Available</option>
                    <option value="Occupied">Occupied</option>
                    <option value="Maintenance">Maintenance</option>
                </select>
            </div>
        </div>
    );
}
